import React, { useState } from 'react'
import PropTypes from 'prop-types'

import UpdatedBy from '../updated-by/updated-by.component'
import useStyles from './updated-by-container.style'

const UpdatedByContainer = ({ data, showDivider }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const classes = useStyles({ isExpanded })

  const displayedData = isExpanded ? data : data.slice(0, 2)

  const handleOnClick = () => {
    setIsExpanded(prev => !prev)
  }

  return (
    <div className={classes.container}>
      {showDivider && <div className={classes.divider} />}
      {displayedData.map((item, index) => (
        <UpdatedBy
          key={`update-key-${index}`}
          index={index}
          item={item}
        />
      ))}
      {data.length > 2 &&
      <button
        className={classes.expandButton}
        onClick={handleOnClick}
      >{isExpanded ? 'Show Less' : 'Show More'}
      </button>}
    </div>
  )
}

UpdatedByContainer.defaultProps = {
  data: [],
  showDivider: false
}

UpdatedByContainer.propTypes = {
  data: PropTypes.array,
  showDivider: PropTypes.bool
}

export default UpdatedByContainer
